/**
 * 메인 라우팅 컴포넌트
 * 통합 반응형 페이지를 라우팅합니다.
 * 모든 페이지는 데스크톱과 모바일을 동시에 지원합니다.
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

// 전역 스타일 및 테마
import GlobalStyle from './styles/GlobalStyle';
import theme from './styles/theme';

// 유틸리티 컴포넌트
import ScrollToTop from './hooks/ScrollToTop';

// 통합 반응형 컴포넌트
import App from './components/App.jsx';
import SiteMap from './pages/SiteMap.jsx';
import HomePage from './pages/HomePage';

// 서브페이지 컴포넌트 (SubPage 템플릿 사용 - 목록 페이지)
import IntroducePage from './subPages/IntroducePage';
import CarePage from './subPages/CarePage';
import NoticePage from './subPages/NoticePage';
import DataPage from './subPages/DataPage';
import PhotoPage from './subPages/PhotoPage';
import SpotSitePage from './subPages/SpotSitePage';
import SupportPage from './subPages/SupportPage';
import StartupPage from './subPages/StartupPage';

// 상세페이지 컴포넌트 (SubPage 템플릿 사용 - 상세 페이지)
import NoticeDetailPage from './detailPages/NoticeDetailPage';
import DataDetailPage from './detailPages/DataDetailPage';
import PhotoDetailPage from './detailPages/PhotoDetailPage';

// React 훅
import React from 'react';

/**
 * Main 컴포넌트
 * 애플리케이션의 최상위 라우팅을 관리합니다.
 */
function Main() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <App>
          <Routes>
            {/* 통합 반응형 라우팅 (데스크톱 + 모바일) */}
            {/* 메인 페이지 */}
            <Route path="/" element={<HomePage />} />

            {/* 사이트맵 */}
            <Route path="/sitemap" element={<SiteMap />} />

            {/* 법인소개 페이지 - :no 파라미터로 서브메뉴 구분 */}
            <Route path="/introduce/:no" element={<IntroducePage />} />

            {/* 사업안내 페이지 - :no 파라미터로 서비스 구분 */}
            <Route path="/care/:no" element={<CarePage />} />

            {/* 후원안내 페이지 - :no 파라미터로 서비스 구분 */}
            <Route path="/support/:no" element={<SupportPage />} />

            {/* 창업지원 페이지 - :no 파라미터로 서비스 구분 */}
            <Route path="/startup/:no" element={<StartupPage />} />

            {/* 공지사항 목록 및 상세 페이지 */}
            <Route path="/notice" element={<NoticePage />} />
            <Route path="/notice/:no" element={<NoticeDetailPage />} />

            {/* 언론보도 목록 및 상세 페이지 */}
            <Route path="/data" element={<DataPage />} />
            <Route path="/data/:no" element={<DataDetailPage />} />

            {/* 포토갤러리 목록 및 상세 페이지 */}
            <Route path="/photo" element={<PhotoPage />} />
            <Route path="/photo/:no" element={<PhotoDetailPage />} />

            {/* 지점소개 페이지 */}
            <Route path="/spotsite" element={<SpotSitePage />} />
          </Routes>
        </App>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default Main;
